
import FastImage from "../../../../globals/elements/fastimg"
export default function Service5({ options, data }) 
{
    return (
        <div className="section-full bg-change-section overlay-wraper p-t80 p-b50">
            <div className="overlay-main bg-secondry opacity-09" />
            <div className="bg-changer">
                <div className=" section-bg active" style={{ backgroundImage: `url(${options.image})` }} />
              
            </div>
            <div className="container">
                {/* TITLE START*/}
                <div className="section-head text-center text-white">
                    <h2 data-title="Services">{options?.title} </h2>
                    <div className="mt-separator-outer">
                        <div className="mt-separator site-bg-primary" />
                    </div>
                </div>
                {/* TITLE END*/}
                <div className="section-content">
                    <div className="row d-flex justify-content-center">
                        {
                            data && data.map((item,index) => {
                                return (
                                    <div className="col-lg-4 col-md-6 m-b30" key={`d-${index}`}>
                                        <div className="mt-icon-box-wraper center  p-a30 bgcall-block  bdr-1 bdr-solid bdr-primary hover-shadow">
                                            <div className="mt-icon-box-sm radius bdr-2 bdr-solid bdr-white m-b20">
                                                <span className="icon-cell  site-text-primary">
                                                    <FastImage src={item?.img?.url}/>
                                                </span>
                                            </div>
                                            <div className="icon-content">
                                                <h4 className="mt-tilte  m-b15 site-text-primary">{item?.title}</h4>
                                                <p className="text-white">{item?.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                    </div>
                </div>
            </div>
        </div>
    )
}